import { windowExists } from '@classity-edtech/ui-base';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (windowExists) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
